export default {
    showing: 'Afficher',
    to: 'à',
    of: 'de',
    result: 'résultats',
};
